import { render, staticRenderFns } from "./SupportingDocumentsComponent.vue?vue&type=template&id=9499719c&"
import script from "./SupportingDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./SupportingDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports